import React from 'react';
import PropTypes from 'prop-types';

import http from 'api/http';
import {trailerAPI} from 'api/requests';

import Row from './Row';
import Pagination from 'Components/Pagination';
import RowsSelector from 'Components/RowsSelector';
import FiltersSection from './FiltersSection';
import TableHeader from './TableHeader';
import EmptyList from 'Components/EmptyList';
import {Input, inputStyleClasses} from 'Components/Input';

const SEARCHABLE_FIELDS = ['id', 'name'];

export default class List extends React.Component {
  constructor(props) {
    super(props);

    this.defaultState = {
      expandedRowId: 0,
      activePage: 1,
      selectedRowsCount: 10,
      selectedStatus: 'All',
      selectedYear: 0,
      currentModelYear: 0,
      sortedBy: 'id',
      sortAsc: -1,
      filter:{year:0},
      searchString:'',
    };

    const storedState = props.user.getStoredState('listState', this.defaultState);
    props.user.updateURLSearchString(storedState);

    this.state = {
      ...this.defaultState,
      ...storedState
    };

    this.state.yearRequestInProcess = !this.state.filter.year;
  }

  componentDidMount() {
    const {user} = this.props;

    http.get(trailerAPI.currentModelYear)
      .then(({data: currentModelYear}) => {
        this.setState(prevState => ({
          currentModelYear,
          filter:{...prevState.filter, year: user.getSelectedYear() || currentModelYear}, yearRequestInProcess:false}));
      });
  }

  componentWillUnmount() {
    this.props.user.saveState('listState', this.state, ['currentModelYear', 'yearRequestInProcess', 'selectedYear']);
  }

  handleRowsSelect = (rowsCountSelected, totalRowsCount) => {
    const {user} = this.props;

    const selectedRowsCount = (rowsCountSelected && rowsCountSelected < totalRowsCount) ? rowsCountSelected : 0;

    const state = {selectedRowsCount, activePage: 1};
    this.setState(state, user.updateURLSearchString(state));
  };

  _handleActivePageChange = activePage => {
    const {user} = this.props;
    this.setState({activePage}, user.updateURLSearchString({activePage}));
  };

  _filterList = componentList => {
    const {filter, searchString} = this.state;

    const doesSearchableFieldsContainSearchString = (element) => {
      for (let searchableFieldIndex in SEARCHABLE_FIELDS) {
        if (element[SEARCHABLE_FIELDS[searchableFieldIndex]]) {
          if (element[SEARCHABLE_FIELDS[searchableFieldIndex]].toString().toLowerCase()
            .includes(searchString.toLowerCase())) return true;
        }
      }
      return false;
    };

    return componentList.filter(element => {
      for (let filterFieldName in filter) {
        switch (filterFieldName) {
          case 'status':
            if (element[filterFieldName].toLowerCase() !== filter[filterFieldName].toLowerCase()) {
              return false;
            }
            break;
          default:
            if (element[filterFieldName] !== filter[filterFieldName]) {
              return false;
            }
        }
      }
      return (!searchString || doesSearchableFieldsContainSearchString(element));
    });
  };

  handleSelectFilter = filterFieldName => filterElement => {
    const {user} = this.props;
    const newFilterFieldValue = filterElement.value !== undefined ? filterElement.value : filterElement;
    let newFilterState = this.state.filter;

    if (newFilterFieldValue === 'All') delete newFilterState[filterFieldName];
    else newFilterState[filterFieldName] = newFilterFieldValue;

    if (filterFieldName === 'year') {
      if (filterElement === 'All') {
        user.saveSelectedYear('');
      } else {
        user.saveSelectedYear(filterElement);
      }
    }

    this.setState({filter: newFilterState, activePage: 1},
      () => {
        user.updateURLSearchString({filter: this.state.filter, activePage: 1});
      }
    );
  };

  handleSearchStringInput = value => {
    const {user} = this.props;
    this.setState({searchString:value, activePage:1}, () => {user.updateURLSearchString({searchString:value});});
  };

  _sortList = (a, b) => {
    const {sortedBy, sortAsc} = this.state;

    switch (sortedBy) {
      case 'id':
        return +a.id > +b.id ? sortAsc : -sortAsc;
      default:
        return a[sortedBy].toString().toLowerCase().replace(/\s+/g, ' ') > b[sortedBy].toString().toLowerCase().replace(/\s+/g, ' ') ? sortAsc : -sortAsc;
    }
  };

  handleSort = sortedBy => () => {
    this.setState(prevState => ({
      sortedBy,
      sortAsc: -prevState.sortAsc
    }), this.props.user.updateURLSearchString({sortedBy, sortAsc: this.state.sortAsc}));
  };

  _getList = () => {
    const {expandedRowId, activePage, selectedRowsCount, currentModelYear, sortedBy, yearRequestInProcess} = this.state;
    const {list, updateLocationState, selectTrailer, user, updateList, listRequestInProcess} = this.props;
    const filteredList = this._filterList(list).sort(this._sortList);
    const sliceFrom = (activePage - 1) * selectedRowsCount;
    const sliceTo = selectedRowsCount ? activePage * selectedRowsCount : filteredList.length;

    let resultList = [];
    let resultLength = 0;

    if (!list.length || yearRequestInProcess) {
      if (listRequestInProcess || yearRequestInProcess) {
        resultList = [
          <div key="spinner" className='ect-spinner _height_120'>
            <div className='ect-spinner__image'  style={{width: 50, height: 50}} />
          </div>
        ];
      } else {
        resultList = [
          <EmptyList key="empty">
            No trailers for selected manufacturer.
          </EmptyList>
        ];
      }
    } else if (!filteredList.length) {
      resultList = [
        <EmptyList key="empty">
          No trailers found with selected filters.
        </EmptyList>
      ];
    } else {
      resultList = filteredList.slice(sliceFrom, sliceTo).map((trailer, index) => {
        return (
          <Row
            key={trailer.id}
            trailer={trailer}
            isOdd={!!(index % 2)}
            toggleRow={this.toggleRow}
            expandedRowId={expandedRowId}
            updateLocationState={updateLocationState}
            currentModelYear={currentModelYear}
            selectTrailer={selectTrailer}
            updateList={updateList}
            user={user}
            sortedBy={sortedBy}
          />
        );
      });
      resultLength = filteredList.length;
    }

    return {resultList, resultLength};
  };

  toggleRow = expandedRowId => () => {
    if (expandedRowId === this.state.expandedRowId) expandedRowId = '';

    this.setState({expandedRowId});
  };

  render() {
    const {activePage, selectedRowsCount, sortAsc, sortedBy, filter, currentModelYear, searchString} = this.state;
    const {resultList, resultLength} = this._getList();

    return (
      <section className='scene__scene-wrapper'>
        <section className='scene__content-wrapper list-scene__content-wrapper'>
          <header className='scene__scene-header list-scene__scene-header'>
            Trailer Model List
            <Input
              mainWrapperClassName='list-scene__header-search-field-wrapper'
              styleClass={inputStyleClasses.searchBar}
              placeholder='Type here to search'
              maxLength={250}
              value={searchString}
              onChange={this.handleSearchStringInput}
            />
          </header>
          <FiltersSection
            outCount={resultLength}
            handleRowsSelect={this.handleRowsSelect}
            rowsCount={selectedRowsCount}
            handleSelectFilter={this.handleSelectFilter}
            filterState={filter}
            currentModelYear={currentModelYear}
          />

          <TableHeader handleSortClick={this.handleSort} order={sortAsc === 1} sortedBy={sortedBy} />

          {resultList}

          <footer className='list-scene__footer'>
            <RowsSelector
              allRowsCount={resultLength}
              selectedRowsCount={selectedRowsCount}
              handleRowsSelect={this.handleRowsSelect}
            />
            <Pagination
              className='_height_80'
              activePage={activePage}
              handleClick={this._handleActivePageChange}
              allRowsCount={resultLength}
              selectedRowsCount={selectedRowsCount}
            />
          </footer>
        </section>
      </section>
    );
  }
}

List.propTypes = {
  list: PropTypes.array.isRequired
};



// WEBPACK FOOTER //
// ./src/app/Scenes/TrailerManufacturer/List/index.jsx